import React, { useRef, useEffect, useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { CheckboxDropdownContext } from '../context';
import styles from '@dtsl/css-checkbox-dropdown/dist/index.module.css';
function CheeckboxDropdown(props) {
  const checkboxDropdownRef = useRef(null);
  const {
    isOpen,
    setIsOpen
  } = useContext(CheckboxDropdownContext);
  const {
    children,
    className
  } = props;
  const dropdownClass = classNames({
    [styles['sib-checkbox-dropdown']]: true,
    [styles['is-open']]: isOpen,
    [className]: !!className
  });
  const handleDocumentClick = event => {
    if (checkboxDropdownRef.current) {
      if (!checkboxDropdownRef.current.contains(event.target) && isOpen) {
        setIsOpen(false);
      }
    }
  };
  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);
    return () => {
      document.addEventListener('click', handleDocumentClick);
    };
  }, [isOpen]);
  return /*#__PURE__*/React.createElement("div", {
    ref: checkboxDropdownRef,
    className: dropdownClass
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['sib-checkbox-dropdown-root']
  }, children));
}
CheeckboxDropdown.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
export default CheeckboxDropdown;